/**
 * useDataView — shared view-mode hook (card | list) for every module,
 * tab, and sub-tab.  Persists to localStorage per `scope` key so each
 * page remembers the user's last choice independently.
 *
 * Usage:
 *   const [view, setView] = useDataView("crm_clients", "list");
 *   <ViewModeToggle mode={view} onChange={setView} />
 */
import { useCallback, useState, useEffect } from "react";

const KEY = (scope) => `pk_view_mode:${scope || "global"}`;

export function useDataView(scope, initial = "list") {
  const [mode, setMode] = useState(() => {
    try {
      const v = localStorage.getItem(KEY(scope));
      return v === "card" || v === "list" ? v : initial;
    } catch { return initial; }
  });
  useEffect(() => {
    try { localStorage.setItem(KEY(scope), mode); } catch { /* noop */ }
  }, [scope, mode]);
  const set = useCallback((next) => setMode(next === "card" ? "card" : "list"), []);
  return [mode, set];
}

export default useDataView;
